import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ColorPalletService {
    private recentlyUsedColors = new BehaviorSubject<string[]>([]);
    public recentlyUsedColors$ = this.recentlyUsedColors.asObservable();
    private readonly STORAGE_KEY = 'recentlyUsedColors';
    private readonly MAX_STORED = 15;

    constructor() {
        this.recentlyUsedColors.next(this.getAllRecentColors());
    }

    addColor(color: string) {
        let storedColors: string[] = this.getAllRecentColors();
        storedColors = storedColors.filter((c) => c !== color);
        storedColors.push(color);
        if (storedColors.length > this.MAX_STORED) {
            storedColors.shift();
        }
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(storedColors));
        this.recentlyUsedColors.next(storedColors);
    }

    private getAllRecentColors(): string[] {
        const raw = localStorage.getItem(this.STORAGE_KEY);
        const stored = JSON.parse(raw || '[]');
        return Array.isArray(stored) ? stored : [];
    }
}
